import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class SchedulesService {
    static getCadence = async (id: number) => {
        try {
            //return await Http.get(`${API_URLs.schedules.schedulesurl}?type=NORMAL`)
            return await Http.get(`${API_URLs.schedules.schedulesurl}/${id}`)
        } catch (error) {
            return error;
        }
    }

    static getCadencesList = async (params?: any) => {
        try {
            return await Http.get(`${API_URLs.schedules.schedulesurl}?type=SPECIFIC`, params)
        } catch (error) {
            return error;
        }
    }

    static getNormalCadencesList = async (params?: any) => {
        try {
            return await Http.get(`${API_URLs.schedules.schedulesurl}?type=NORMAL`, params)
        } catch (error) {
            return error;
        }
    }
    
    static postCadence = async (data: any) => {
        try {
            return await Http.post(`${API_URLs.schedules.schedulesurl}`, data)
        } catch (error) {
            return error;
        }
    }
    static patchCadence = async (data: any) => {
        try {
            return await Http.patch(`${API_URLs.schedules.schedulesurl}`, data)
        } catch (error) {
            return error;
        }
    }
    static deleteCadence = async (id: number) => {
        try {
            return await Http.delete(`${API_URLs.schedules.schedulesurl}`, id)
        } catch (error) {
            return error;
        }
    }


}